module.exports = __webpack_public_path__ + "static/media/24_tn.fa283f2c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/style/img/outerborders/thumbnails/24_tn.jpg
// module id = 162
// module chunks = 0